// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-container[data-v-58a154c8]{position:fixed;top:32px;left:50%;transform:translateX(-50%);min-width:320px;z-index:1000}", ""]);
// Exports
module.exports = exports;
